"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var IComponentServer_1 = require("../IComponentServer");
var store = {};
/**
 * class TUIGroupServer
 *
 * TUIGroup 逻辑主体
 */
var TUIGroupServer = /** @class */ (function (_super) {
    __extends(TUIGroupServer, _super);
    function TUIGroupServer(TUICore) {
        var _this = _super.call(this) || this;
        _this.currentStore = {};
        _this.TUICore = TUICore;
        _this.bindTIMEvent();
        _this.store = TUICore.setComponentStore('TUIGroup', store, _this.updateStore.bind(_this));
        return _this;
    }
    /**
     * 组件销毁
     */
    TUIGroupServer.prototype.destroyed = function () {
        this.unbindTIMEvent();
    };
    /**
     * 数据监听回调
     *
     * @param {any} newValue 新数据
     * @param {any} oldValue 旧数据
     */
    TUIGroupServer.prototype.updateStore = function (newValue, oldValue) {
        this.currentStore.groupList = newValue.groupList;
        this.currentStore.searchGroup = newValue.searchGroup;
    };
    /**
     * /////////////////////////////////////////////////////////////////////////////////
     * //
     * //                                    TIM 事件监听注册接口
     * //
     * /////////////////////////////////////////////////////////////////////////////////
     */
    TUIGroupServer.prototype.bindTIMEvent = function () {
        this.TUICore.tim.on(this.TUICore.TIM.EVENT.GROUP_LIST_UPDATED, this.handleGroupListUpdated, this);
        this.TUICore.tim.on(this.TUICore.TIM.EVENT.GROUP_ATTRIBUTES_UPDATED, this.handleGroupAttributesUpdated, this);
    };
    TUIGroupServer.prototype.unbindTIMEvent = function () {
        this.TUICore.tim.off(this.TUICore.TIM.EVENT.GROUP_LIST_UPDATED, this.handleGroupListUpdated);
        this.TUICore.tim.off(this.TUICore.TIM.EVENT.GROUP_ATTRIBUTES_UPDATED, this.handleGroupAttributesUpdated);
    };
    TUIGroupServer.prototype.handleGroupListUpdated = function (event) {
        this.store.groupList = event.data;
    };
    TUIGroupServer.prototype.handleGroupAttributesUpdated = function (event) {
        var _a = event.data, groupID = _a.groupID, groupAttributes = _a.groupAttributes; // 群组ID // 更新后的群属性
        console.log(groupID, groupAttributes);
    };
    /**
     * /////////////////////////////////////////////////////////////////////////////////
     * //
     * //                                 处理 TIM 接口参数及回调
     * //
     * /////////////////////////////////////////////////////////////////////////////////
     */
    /**
     * 处理异步函数
     *
     * @param {callback} callback 回调函数
     * @returns {Promise} 返回异步函数
     */
    TUIGroupServer.prototype.handlePromiseCallback = function (callback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var config = {
                TUIName: 'TUIGroup',
                callback: function () {
                    callback && callback(resolve, reject);
                },
            };
            _this.TUICore.setAwaitFunc(config.TUIName, config.callback);
        });
    };
    /**
     * /////////////////////////////////////////////////////////////////////////////////
     * //
     * //                                 对外方法
     * //
     * /////////////////////////////////////////////////////////////////////////////////
     */
    /**
     * 获取群组列表
     *
     * @param {any} options 参数
     * @param {Array.<String>} options.groupProfileFilter 群资料过滤器
     * @returns {Promise}
     */
    TUIGroupServer.prototype.getGroupList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var imResponse, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 5, , 6]);
                                    imResponse = {};
                                    if (!!options) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.TUICore.tim.getGroupList()];
                                case 1:
                                    imResponse = _a.sent();
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, this.TUICore.tim.getGroupList(options)];
                                case 3:
                                    imResponse = _a.sent();
                                    _a.label = 4;
                                case 4:
                                    this.store.groupList = imResponse.data.groupList;
                                    resolve(imResponse);
                                    return [3 /*break*/, 6];
                                case 5:
                                    error_1 = _a.sent();
                                    reject(error_1);
                                    return [3 /*break*/, 6];
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * 获取群组属性
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Array.<String>} options.groupProfileFilter 群资料过滤器
     * @returns {Promise}
     */
    TUIGroupServer.prototype.getGroupProfile = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.getGroupProfile(options)];
                    case 1:
                        imResponse = _a.sent();
                        this.store.groupList = imResponse.data.groupList;
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        reject(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 创建群组
     *
     * @param {any} options 参数
     * @param {String} options.name 群组名称
     * @param {String} options.type 群组类型
     * @param {String} options.groupID 群组ID
     * @param {String} options.introduction 群简介
     * @param {String} options.notification 群公告
     * @param {String} options.avatar 群头像 URL
     * @param {Number} options.maxMemberNum 最大群成员数量
     * @param {Number} options.joinOption 申请加群处理方式
     * @param {Array.<Object>} options.memberList 初始群成员列表
     * @param {Array.<Object>} options.groupCustomField 群组维度的自定义字段
     * @returns {Promise}
     */
    TUIGroupServer.prototype.createGroup = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.createGroup(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        reject(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 删除群组
     *
     * @param {String} groupID 群组ID
     * @returns {Promise}
     */
    TUIGroupServer.prototype.dismissGroup = function (groupID) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.dismissGroup(groupID)];
                    case 1:
                        imResponse = _a.sent();
                        this.store.groupProfile = imResponse.data.group;
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        reject(error_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 修改群组资料
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {String} options.name 群组名称
     * @param {String} options.introduction 群简介
     * @param {String} options.notification 群公告
     * @param {String} options.avatar 群头像 URL
     * @param {Number} options.maxMemberNum 最大群成员数量
     * @param {Number} options.joinOption 申请加群处理方式
     * @param {Array.<Object>} options.groupCustomField 群组维度的自定义字段
     * @returns {Promise}
     */
    TUIGroupServer.prototype.updateGroupProfile = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.updateGroupProfile(options)];
                    case 1:
                        imResponse = _a.sent();
                        this.store.groupProfile = imResponse.data.group;
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        reject(error_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 申请加群
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {String} options.applyMessage 附言
     * @param {String} options.type 群组类型
     * @returns {Promise}
     */
    TUIGroupServer.prototype.joinGroup = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.joinGroup(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        reject(error_6);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 退出群组
     *
     * @param {String} groupID 群组ID
     * @returns {Promise}
     */
    TUIGroupServer.prototype.quitGroup = function (groupID) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.quitGroup(groupID)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_7 = _a.sent();
                        reject(error_7);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 通过 groupID 搜索群组
     *
     * @param {String} groupID 群组ID
     * @returns {Promise}
     */
    TUIGroupServer.prototype.searchGroupByID = function (groupID) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.searchGroupByID(groupID)];
                    case 1:
                        imResponse = _a.sent();
                        this.store.searchGroup = imResponse.data.group;
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_8 = _a.sent();
                        reject(error_8);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 获取群在线人数
     * - 只用于查询直播群在线人数
     *
     * @param {String} groupID 群组ID
     * @returns {Promise}
     */
    TUIGroupServer.prototype.getGroupOnlineMemberCount = function (groupID) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.getGroupOnlineMemberCount(groupID)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_9 = _a.sent();
                        reject(error_9);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 转让群组
     * - 只有群主有权限操作
     *
     * @param {any} options 参数
     * @param {String} options.groupID 待转让的群组 ID
     * @param {String} options.newOwnerID 新群主的 ID
     * @returns {Promise}
     */
    TUIGroupServer.prototype.changeGroupOwner = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.changeGroupOwner(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_10 = _a.sent();
                        reject(error_10);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 处理申请加群
     * - 管理员
     *
     * @param {any} options 参数
     * @param {String} options.handleAction 处理结果 Agree(同意) / Reject(拒绝)
     * @param {String} options.handleMessage 附言
     * @param {Message} options.message 对应【群系统通知】的消息实例
     * @returns {Promise}
     */
    TUIGroupServer.prototype.handleGroupApplication = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.handleGroupApplication(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_11 = _a.sent();
                        reject(error_11);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 初始化群属性
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Object} options.groupAttributes 群属性
     * @returns {Promise}
     */
    TUIGroupServer.prototype.initGroupAttributes = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.initGroupAttributes(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_12 = _a.sent();
                        reject(error_12);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 设置群属性
     * - 仅适用于直播群
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Object} options.groupAttributes 群属性
     * @returns {Promise}
     */
    TUIGroupServer.prototype.setGroupAttributes = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.setGroupAttributes(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_13 = _a.sent();
                        reject(error_13);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 删除群属性
     * - 仅适用于直播群
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Array.<String>} options.keyList 群属性 key 列表
     * @returns {Promise}
     */
    TUIGroupServer.prototype.deleteGroupAttributes = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.deleteGroupAttributes(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_14 = _a.sent();
                        reject(error_14);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 获取群属性
     * - 仅适用于直播群
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Array.<String>} options.keyList 群属性 key 列表
     * @returns {Promise}
     */
    TUIGroupServer.prototype.getGroupAttributes = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.getGroupAttributes(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_15 = _a.sent();
                        reject(error_15);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 获取群成员列表
     *
     * @param {Object} options 获取群成员参数
     * @param {String} options.groupID 群组的 ID
     * @param {Number} options.count 需要拉取的数量。最大值：100
     * @param {Number} options.offset 偏移量，默认从0开始拉取
     * @returns {Promise}
     */
    TUIGroupServer.prototype.getGroupMemberList = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.getGroupMemberList(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_16 = _a.sent();
                        reject(error_16);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 添加群成员
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Array.<String>} options.userIDList 待添加的群成员 ID 数组
     * @returns {Promise}
     */
    TUIGroupServer.prototype.addGroupMember = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.addGroupMember(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_17 = _a.sent();
                        reject(error_17);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 删除群成员
     * - 群主可移除群成员
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Array.<String>} options.userIDList 待删除的群成员的 ID 列表
     * @param {String} options.reason 踢人的原因
     * @returns {Promise}
     */
    TUIGroupServer.prototype.deleteGroupMember = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.deleteGroupMember(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_18 = _a.sent();
                        reject(error_18);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 设置群成员的禁言时间
     * - 只有群主和管理员拥有该操作权限
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {String} options.userID 用户 ID
     * @param {Number} options.muteTime 禁言时长，单位秒; 设为0，则表示取消禁言。
     * @returns {Promise}
     */
    TUIGroupServer.prototype.setGroupMemberMuteTime = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.setGroupMemberMuteTime(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_19 = _a.sent();
                        reject(error_19);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 修改群成员角色
     * - 群主拥有操作的权限
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {String} options.userID 用户 ID
     * @param {String} options.role 可选值：TIM.TYPES.GRP_MBR_ROLE_ADMIN（群管理员）,TIM.TYPES.GRP_MBR_ROLE_MEMBER（群普通成员）,TIM.TYPES.GRP_MBR_ROLE_CUSTOM（自定义群成员角色，仅社群支持）
     * @returns {Promise}
     */
    TUIGroupServer.prototype.setGroupMemberRole = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.setGroupMemberRole(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_20 = _a.sent();
                        reject(error_20);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 设置群成员名片
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {String} options.userID 可选，默认修改自身的群名片
     * @param {String} options.nameCard 群成员名片
     * @returns {Promise}
     */
    TUIGroupServer.prototype.setGroupMemberNameCard = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.setGroupMemberNameCard(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_21 = _a.sent();
                        reject(error_21);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 获取群成员资料
     *
     * @param {any} options 参数
     * @param {String} options.groupID 群组ID
     * @param {Array.<String>} options.userIDList 要查询的群成员用户 ID 列表
     * @param {	Array.<String>} options.memberCustomFieldFilter 群成员自定义字段筛选
     * @returns {Promise}
     */
    TUIGroupServer.prototype.getGroupMemberProfile = function (options) {
        var _this = this;
        return this.handlePromiseCallback(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var imResponse, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.TUICore.tim.getGroupMemberProfile(options)];
                    case 1:
                        imResponse = _a.sent();
                        resolve(imResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        error_22 = _a.sent();
                        reject(error_22);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 赋值
     *
     * @param {Object} params 使用的数据
     * @returns {Object} 数据
     */
    TUIGroupServer.prototype.bind = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentStore = params;
                        return [4 /*yield*/, this.getGroupList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.currentStore];
                }
            });
        });
    };
    return TUIGroupServer;
}(IComponentServer_1.default));
exports.default = TUIGroupServer;
